var map = {
	"./CRUD.JPG": 59,
	"./cnn.png": 60,
	"./convnet.png": 61,
	"./cozy.png": 62,
	"./detected.JPG": 63,
	"./elixatec.png": 64,
	"./no_img.png": 15,
	"./resca.png": 65,
	"./scrapy.jpg": 66,
	"./wanon.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;